import * as Dom from './main';
export { Dom };
//# sourceMappingURL=index.js.map